import React, { useEffect, useState } from "react";
import {
  Search,
  Rating,
  Markeplace,
  Status,
  Sorting,
  TagsFilter,
} from "./FilterItems";
import { FilterState } from "./useFilterState";
import { getFilterOptions } from "api/Reviews";
import { getAll as getGoodsTags } from "api/GoodsTags";
import { markeplaceOptions as avalibelMarkeplaceOptions } from "./filterOptions";

export const Filter = (props: { filters: FilterState }) => {
  const [markeplaceOptions, setMarkeplaceOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [tagOptions, setTagOptions] = useState<
    { value: number; label: string }[]
  >([]);
  useEffect(() => {
    const fetchData = async () => {
      const result = await getFilterOptions();
      setMarkeplaceOptions(
        avalibelMarkeplaceOptions.filter((el) =>
          result.marketplaces.includes(el.value)
        )
      );
      try {
        const tags = await getGoodsTags();
        setTagOptions(
          [...tags]
            .sort((a, b) =>
              a.name.localeCompare(b.name, "ru", { sensitivity: "base" })
            )
            .map((t) => ({ value: t.id, label: t.name }))
        );
      } catch {
        setTagOptions([]);
      }
    };
    fetchData();
  }, []);
  return (
    <div>
      <Sorting filters={props.filters}></Sorting>
      <Search filters={props.filters}></Search>
      <TagsFilter filters={props.filters} tagOptions={tagOptions} />
      <Rating filters={props.filters}></Rating>
      <Markeplace
        filters={props.filters}
        markeplaceOptions={markeplaceOptions}
      ></Markeplace>
      <Status filters={props.filters}></Status>
    </div>
  );
};
